import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    breadCrumbContainer: {
      paddingBottom: "20px",
    },
    pageTitle: {
      width: "85%",
      marginBottom: "32px",
      [theme.breakpoints.down("1060")]: {
        width: "100%",
      },
    },
    modalIcon: {
      display: "flex",
      alignItems: "center",
      borderRadius: "50%",
      maxWidth: "48px",
      width: "100%",
      height: "48px",
      background: "#DCFAE6",
      justifyContent: "center",
      marginRight: "16px",
    },
    checkBoxAction: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
    },
    modalCheckBox: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginRight: "auto",
    },
  };
});
